import {VStack, HStack, Flex, SkeletonText, SkeletonCircle} from "@reverb-ui/react";

const isLoaded : boolean = false;

export const TopFiveSkeleton = () : JSX.Element =>  (
  <VStack
    alignItems="start"
    justifyContent="space-between"
    spacing={4}
    px={4}
    py={4}
    bg="white"
    borderRadius="4px"
    h="full"
  >
    <VStack alignItems="start" justifyContent="space-between" spacing={4} w="full">
      <HStack alignItems="center" width={"full"}>
        <SkeletonCircle isLoaded={isLoaded} variant="rect" width={4} height={4} />
        <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"50%"} skeletonHeight={"1rem"} />
      </HStack>
      <Flex w="full" justifyContent="space-between" width={"full"}>
        <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"30%"} skeletonHeight={"1rem"} />
        <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"30%"} skeletonHeight={"1rem"} />
      </Flex>

      {Array(5).fill(0).map((item, index) => (
        <Flex w="full" justifyContent="space-between" key={index} width={"full"} paddingTop={"2%"}>
          <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"50%"} skeletonHeight={"1rem"} />
          <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"20%"} skeletonHeight={"1rem"} />
        </Flex>
      ))}
    </VStack>
  </VStack>
)
